import React from 'react'
import { Container, WemolonIcon, Title, TitleContainer } from './Error.style'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { BUTTON_SIZE, BUTTON_KIND } from 'parkdepot-shared/components/Buttons/types'
import Button from 'parkdepot-shared/components/Buttons/Button'
import { homeRoute } from '@views/Home/route.const'

const Error = () => {
    const { t } = useTranslation()
    const { replace } = useHistory()

    const onHomeClick = () => {
        replace(homeRoute())
    }

    return (
        <Container>
            <TitleContainer>
                <WemolonIcon className="wemolo-wemolon" aria-hidden="true" />
                <Title>{t('errors.errorOnSave')}</Title>
            </TitleContainer>

            <Button id="404-home-button" $kind={BUTTON_KIND.primary} $size={BUTTON_SIZE.medium} onClick={onHomeClick}>
                {t('404.redButtonText')}
            </Button>
        </Container>
    )
}

export default Error
